<template>
<div class="content">
  <van-nav-bar @click-left="onClickLeft">
    <template #left>
      <img style="width: 2.66667vw;height: 5.33333vw;display: inline-block;" :src="require('../../assets/'+appTheme+'/navBack.png')" alt="">
    </template>
  </van-nav-bar>
  <div v-if="isDel">
    <van-address-edit
      :area-list="areaList"
      :address-info="AddressInfo"
      show-delete
      show-set-default
      :area-columns-placeholder="['请选择', '请选择', '请选择']"
      @save="onSaveEdit"
      @delete="onDelete"
    />
  </div>
  <div v-else>
    <van-address-edit
      :area-list="areaList"
      show-set-default
      :area-columns-placeholder="['请选择', '请选择', '请选择']"
      @save="onSave"
    />
  </div>
</div>
</template>

<script>
import { areaList } from '@vant/area-data';
import { addAddress,addressDel,addressEdit } from '@/api/goods'
import { Toast } from 'vant';
export default {
  name: "addressEdit",
  data() {
    return {
      appTheme:this.$store.state.appTheme,
      areaList,
      searchResult: [],
      textAdd:'+新增地址',
      AddressInfo: '',
      isDel: false
    };
  },
  created() {
    var item = this.$route.query.item
    if (item != undefined){
      this.isDel = true
      var str=item.area
      var arr=str.split(" ");
      // console.log(arr[0])
      console.log('有值',item.is_default)
      var isDefault = ''
      if (item.isDefault==1){
        isDefault= true
      } else {
        isDefault= false
      }
      var addInfo = {
        id:item.id,
        name: item.name,
        tel: item.tel,
        area: arr[0],
        city: arr[1],
        county:arr[2],
        addressDetail: item.address,
        isDefault: isDefault,
        areaCode:  item.area_code

      }
      this.AddressInfo = addInfo

      // console.log(this.AddressInfo)
    } else {
      console.log('没有值')
    }
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    onSave(content) { // 新增保存
      // Toast('save');
      console.log(content)
      var isDefault = content.isDefault==false
      if (content.isDefault==false){
        isDefault=0
      } else {
        isDefault=1
      }
      var that = this
      var data = {
        name: content.name,
        phone: content.tel,
        area: content.province+ ' ' +content.city+ ' ' +content.county,
        address: content.addressDetail,
        is_default: isDefault,
        area_code:  content.areaCode
      }
      addAddress(data).then(res => {
        if(res.code == 200)
        {
          Toast(res.message);
          setTimeout(function()  {
            history.go(-1)
          }, 2000);
        }
        else
        {
          this.$toast(res.message)
          // this.$router.push('/');
        }
      })
    },
    onSaveEdit(content){ // 编辑保存
      console.log(content)
      var isDefault = content.isDefault==false
      if (content.isDefault==false){
        isDefault=0
      } else {
        isDefault=1
      }
      var that = this
      var data = {
        name: content.name,
        phone: content.tel,
        area: content.province+ ' ' +content.city+ ' ' +content.county,
        address: content.addressDetail,
        is_default: isDefault,
        area_code:  content.areaCode
      }
      addressEdit(content.id,data).then(res => {
        if(res.code == 200)
        {
          Toast(res.message);
          setTimeout(function()  {
            history.go(-1)
          }, 2000);
        }
        else
        {
          this.$toast(res.message)
          // this.$router.push('/');
        }
      })
    },
    onDelete(content) { // 删除
      addressDel(content.id).then(res => {
        if(res.code == 200)
        {
          Toast(res.message);
          setTimeout(function()  {
            history.go(-1)
          }, 2000);
        }
        else
        {
          this.$toast(res.message)
          // this.$router.push('/');
        }
      })
    },
    onChangeDetail(){},
  }
}
</script>

<style lang="scss" scoped>
.van-nav-bar {
  background: #FDD80D;color: #333333;font-weight: bold;font-size: 30px;
}
.van-nav-bar .van-icon {
  color: #333333;
}
/deep/.van-button--danger {

  color: #282828;
  background-color: #FDD80D;
  border: 0.02667rem solid #FDD80D;
}
/deep/.van-cell__title{
  text-align: left;
}
/deep/.van-address-edit__buttons{
  position: absolute;
  width: 90%;
  left: 5%;
  bottom: 40px;
}
/deep/.van-button--default {
  color: #323233;
  background-color: #fff;
  border: 2px solid #FDD80D;
}
</style>
